import React from "react";
import { Route } from "react-router-dom";
import AccessControl from "../../../components/utilities/Class/AccessControl";
import ValueRangking from "../../../containers/modules/marketing/value-rangking";

export default function ValueRankingRoute(props) {
  const { authUser } = props;
  return (
    <Route
      path="value-ranking"
      index
      element={
        <AccessControl
          name={"Value Ranking List"}
          auth={authUser}
          component={() => <ValueRangking />}
        />
      }
    />
  );
}
